import { NgModule } from '@angular/core';
import { CtvDetailsComponent } from './ctv-details.component';
import { CtvInformationComponent } from './ctv-information/ctv-information.component';
import { CtvOverviewRiskComponent } from './ctv-overview-risk/ctv-overview-risk.component';
import { CommonModule } from '@angular/common';
import { routing } from './ctv-details.routing';
import { PipesModule } from '../../../../pipes/pipes.module';
import { CtvAppDetailsComponent } from './ctv-app-details/ctv-app-details.component';
import { CtvDeveloperOverviewComponent } from './ctv-developer-overview/ctv-developer-overview.component';
import { CtvPlatformDistributionComponent } from './ctv-platform-distribution/ctv-platform-distribution.component';
import { CtvBrandsafetyComponent } from './ctv-brandsafety/ctv-brandsafety.component';
import { CtvTrafficOverlapComponent } from './ctv-traffic-overlap/ctv-traffic-overlap.component';
import { CtvAuthorizedSellerComponent } from './ctv-authorized-seller/ctv-authorized-seller.component';
import { DataTableModule } from '../../../data-table/data-table.module';
import { TooltipModule } from '../../../tooltip/tooltip.module';
import { CtvIvtComponent } from './ctv-ivt/ctv-ivt.component';
import { DirectivesModule } from '../../../../directives/directives.module';
import { CtvInventoryComponent } from './ctv-inventory/ctv-inventory.component';
import { CtvChannelsComponent } from './ctv-channels/ctv-channels.component';
import { CtvAppSpoofingComponent } from './ctv-app-spoofing/ctv-app-spoofing.component';
import { CtvAdSpendComponent } from './ctv-ad-spend/ctv-ad-spend.component';
import { SharedModule } from '../../../shared/shared.module';
import { SuggestFeedbackModule } from '../../../suggest-feedback/suggest-feedback.module';
import { DetailsPageModule } from '../details-page/details-page.module';
import { AppOverviewSectionComponent } from './sections/app-overview-section/app-overview-section.component';
import { AppRiskOverviewSectionComponent } from './sections/app-risk-overview-section/app-risk-overview-section.component';
import { AppSpoofingSectionComponent } from './sections/app-spoofing-section/app-spoofing-section.component';
import { AppDetailsSectionComponent } from './sections/app-details-section/app-details-section.component';
import { AppDeveloperOverviewSectionComponent } from './sections/app-developer-overview-section/app-developer-overview-section.component';
import { AppCountryRankingsSectionComponent } from './sections/app-country-rankings-section/app-country-rankings-section.component';
import { AppChannelsSectionComponent } from './sections/app-channels-section/app-channels-section.component';
import { AppPlatformDistributionSectionComponent } from './sections/app-platform-distribution-section/app-platform-distribution-section.component';
import { AppBrandSafetySectionComponent } from './sections/app-brand-safety-section/app-brand-safety-section.component';
import { AppTrafficTrendsSectionComponent } from './sections/app-traffic-trends-section/app-traffic-trends-section.component';
import { AppAuthorizedSellerSectionComponent } from './sections/app-authorized-seller-section/app-authorized-seller-section.component';
import { AppIvtSectionComponent } from './sections/app-ivt-section/app-ivt-section.component';
import { AppAdSpendSectionComponent } from './sections/app-ad-spend-section/app-ad-spend-section.component';
import { AppInventorySectionComponent } from './sections/app-inventory-section/app-inventory-section.component';
import { SwiperModule } from 'swiper/angular';
import { ChartsModule } from '../../charts/charts.module';
import { AppCtvCoppaViolationRiskSectionComponent } from './sections/ctv-coppa-violation-risk-section/ctv-coppa-violation-risk-section.component';
import { CtvCoppaPermissions } from './ctv-coppa-permissions/ctv-coppa-permissions';
import { InsightBadgesModule } from '../../../shared/insight-badges/insight-badges.module';
import { CtvAppMfaComponent } from './ctv-app-mfa/ctv-app-mfa';
import { AppMfaSectionComponent } from './sections/app-mfa-section/app-mfa-section.component';

@NgModule({
  declarations: [
    CtvDetailsComponent,
    CtvInformationComponent,
    CtvOverviewRiskComponent,
    CtvAppDetailsComponent,
    CtvAppMfaComponent,
    CtvDeveloperOverviewComponent,
    CtvCoppaPermissions,
    CtvPlatformDistributionComponent,
    CtvBrandsafetyComponent,
    CtvTrafficOverlapComponent,
    CtvAuthorizedSellerComponent,
    CtvIvtComponent,
    CtvAdSpendComponent,
    CtvInventoryComponent,
    CtvChannelsComponent,
    CtvAppSpoofingComponent,
    AppOverviewSectionComponent,
    AppRiskOverviewSectionComponent,
    AppSpoofingSectionComponent,
    AppDetailsSectionComponent,
    AppDeveloperOverviewSectionComponent,
    AppCountryRankingsSectionComponent,
    AppCtvCoppaViolationRiskSectionComponent,
    AppChannelsSectionComponent,
    AppPlatformDistributionSectionComponent,
    AppBrandSafetySectionComponent,
    AppTrafficTrendsSectionComponent,
    AppAuthorizedSellerSectionComponent,
    AppMfaSectionComponent,
    AppIvtSectionComponent,
    AppAdSpendSectionComponent,
    AppInventorySectionComponent
  ],
  imports: [
    DetailsPageModule,
    DirectivesModule,
    TooltipModule,
    DataTableModule,
    PipesModule,
    CommonModule,
    SharedModule,
    routing,
    SuggestFeedbackModule,
    SwiperModule,
    ChartsModule,
    InsightBadgesModule
  ],
  exports: []
})
export class CtvDetailsModule {}
